module.exports = __webpack_public_path__ + "img/waveform.9a0b23c3.svg";